<template>
  <div class="product-container">
    <el-image :src="topImage" :fit="fit" class="mb-10 bs-10 br-10 db" style="height: 400px;"></el-image>
    <div class="category mb-10 bs-10 br-10">
      <h2><em>Case Category</em></h2>
      <el-divider>
        <!--i class="el-icon-s-grid"></i-->
      </el-divider>
      <div class="title" style="width: 100%;">
        <el-row :gutter="10">
          <el-col :span="4" v-for="(type,index) in types" :key="index">
            <el-button @click="handleTypeClick(type)" style="width: 100%;">{{type.casesType}}</el-button>
          </el-col>
          <el-col :span="4">
            <el-button v-on:click="showCategory()">MORE</el-button>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="h-10"></div>
    <div v-for="(data,index) in datas" :key="index">
      <el-image :src="data.url" :fit="fit" @click="showDetail(data.id)" class="mb-10 bs-10 br-10 db" style="height: 600px;cursor: pointer;"></el-image>
    </div>
    <div class="h-60"></div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        topImage: '',
        fit: 'fit',
        datas: {},
        types: {},
        /*fits: ['fill', 'contain', 'cover', 'none', 'scale-down'],
        topImages: [],
        images: []*/
      }
    },
    methods: {
      showDetail(id) {
        this.$router.push({
          name: 'CaseDetail',
          params: {
            id: id
          }
        });
      },
      handleTypeClick(item){
        //console.log(item);
        this.$router.push({ name: 'CaseCategory', params: { id: item.id }});
      },
      showCategory() {
        this.$router.push('/case-category');
      },
      getTpye() {
        this.$axios.get('/api/casestype').then(res => {
            //console.log(res.data);
            if (res.data.code == '0') {
              this.types = res.data.data;
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              })
            }
          })
          .catch(function(error) { // 请求失败处理
            console.log(error);
          });
      },
      getData() {
        this.$axios.get('/api/cases/recommend').then(res => {
            //console.log(res.data);
            if (res.data.code == '0') {
              this.datas = res.data.data;
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              })
            }
          })
          .catch(function(error) { // 请求失败处理
            console.log(error);
          });
      },
      getTopImage() {
        this.$axios.get('/api/topimage/case').then(res => {
            //console.log(res.data);
            if (res.data.code == '0') {
              this.topImage = res.data.data[0].url;
              /*this.$message({
              	message: res.data.msg,
              	type: 'success',
              });*/
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              })
            }
          })
          .catch(function(error) { // 请求失败处理
            console.log(error);
          });
      },
    },
    mounted: function() {
      this.getTopImage();
      this.getTpye();
      this.getData();
    }
  }
</script>

<style scoped>
  .product-container {
    max-width: 1200px;
    margin: 0 auto;
    margin-bottom: 50px;
  }

  .category {
    background-color: #fff;
    padding: 0 10px;
    padding-top: 20px;
    padding-bottom: 20px;
    height: 170px;
  }

  .category:after {
    display: block;
    content: '';
    clear: both;
    height: 0;
    overflow: hidden
  }

  .category h2 {
    text-align: center;
    /*height: 30px;
      margin-bottom: 26px;
    background-color: #fff;*/
  }

  .category h2 em {
    display: block;
    font-size: 20px;
    color: #cecece;
    text-transform: uppercase;
    font-weight: normal;
  }

  .category .title {
    float: left;
    overflow: hidden;
    white-space: nowrap;
  }

  .category .title button {
    width: 98%;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Case.vue